import { useItemsCount } from ".";
export function useItemsChecked() {
  const itemsCount = useItemsCount();
  if (!itemsCount) {
    return false;
  }
  const {
    totalCount,
    selectedCount
  } = itemsCount;
  if (selectedCount === 0) {
    return false;
  }
  if (totalCount === selectedCount) {
    return true;
  }
  return "indeterminate";
}